module.exports = __webpack_public_path__ + "static/img/tencent.87f621f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/tencent.png
// module id = sK0k
// module chunks = 1